export default {
  CreditNoteOfRelatedDocuments: '01',
  DebitNoteOfRelatedDocuments: '02',
  ReturnOfProductsOnInvoices: '03',
  ReplacementOfPreviousCfdis: '04',
  TransfersOfPreviouslyInvoiced: '05',
  InvoiceByPreviousTransfers: '06',
  CfdiByApplicationOfAdvance: '07',
  InvoiceByPartialPayments: '08',
  InvoiceByDeferredPayments: '09',
};
